
import { defineComponent, ref, Ref } from 'vue';
import { IClaimMedia } from '@/types';
import ZoomableImage from '@/components/ZoomableImage.vue';

export default defineComponent({
  name: 'ClaimMediaGallery',
  components: {
    ZoomableImage,
  },
  props: {
    media: Array,
    isSharable: {
      // flag to display the share with vendor checkbox
      type: Boolean,
      default: true,
    },
    selectedMedia: Object,
  },
  emits: ['toggleShare'],
  setup(props, { emit }) {
    const currentMedia: Ref<IClaimMedia | null> = ref<IClaimMedia | null>(
      props.selectedMedia
        ? (props.selectedMedia as IClaimMedia)
        : props.media?.length
        ? (props.media[0] as IClaimMedia)
        : null
    );

    const onToggleCheckbox = () => {
      if (!currentMedia.value) return;

      currentMedia.value.isPrivate = !currentMedia.value.isPrivate;

      // have to define by using camelCase, due to the browser warning
      // [Vue warn]: Extraneous non-emits event listeners (toggleShare) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.
      // eslint-disable-next-line vue/custom-event-name-casing
      emit('toggleShare', currentMedia.value);
    };

    const selectMedia = (media: IClaimMedia) => {
      currentMedia.value = media;
    };

    return {
      currentMedia,
      selectMedia,
      onToggleCheckbox,
    };
  },
});
